@if (!isEditable && !isCreateExclusion) {
  <div class="col-12">
    <div class="padding-bottom-a-rem">
      <span>{{ detailTextLine1 }}</span>
    </div>
    <div class="padding-bottom-a-rem">
      <span [innerHTML]="detailTextLine2"></span>
    </div>
    <div class="padding-bottom-a-rem">
      <span>{{ detailTextLine3 }}</span>
    </div>
    @if (isChildReinstatedOrWithdrawn) {
      <div class="padding-bottom-a-rem">
        <span [innerHTML]="detailTextLine4"></span>
      </div>
    }
  </div>
  @if (!pupilData.isOffRoll || isOffRollEditingEnabled) {
    <div class="grid">
      <div class="col">
        <button
          pButton
          type="button"
          [routerLink]="['/']"
          label="Edit Exclusion Details"
          class="float-right"
          style="width: auto"
          [routerLink]="['.']"
          (click)="toggleEditing()"
          #buttonExclusionDetails
        ></button>
      </div>
    </div>
  }
}
@if (isEditable || isCreateExclusion) {
  <form [formGroup]="userFields">
    <div class="required-field-disclaimer padding-bottom-a-rem">
      Mandatory fields are marked with a red asterisk
      <span class="red">*</span>
    </div>
    <div class="grid">
      <div class="col-12 padding-zero">
        <div class="col-6 padding-zero">
          <div class="col-6">
            <label for="category"
              >Exclusion category <span class="error-label">*</span></label
            >
            <div>
              @if (categoryList?.length > 0) {
                <p-select
                  id="category"
                  formControlName="category"
                  [options]="categoryList"
                  optionLabel="description"
                  optionValue="internalCode"
                  (onChange)="onCategoryChange($event.value)"
                  placeholder="Please select"
                  #dropdownCategory
                ></p-select>
              }
            </div>
            @if (
              (f.category.invalid && f.category.touched) || f.category.dirty
            ) {
              <div class="clear-both">
                @if (f.category.errors?.required) {
                  <small class="error-label"
                    >Exclusion category is required</small
                  >
                }
              </div>
            }
          </div>
        </div>
      </div>
      @if (isStartDateVisible) {
        <div class="col-6 padding-zero">
          <div class="col-6">
            <label for="startDate"
              >Start date <span class="error-label">*</span></label
            >
            <div>
              <p-datepicker
                class="calendar-size float-left"
                dateFormat="dd/mm/yy"
                placeholder="DD/MM/YYYY"
                inputId="startDate"
                keepInvalid="true"
                showIcon="true"
                formControlName="startDate"
                autoZIndex="true"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [minDate]="minSchoolHistoryDate"
                [maxDate]="maxSchoolHistoryDate"
                [yearRange]="yearRangeNavigator"
                [disabledDates]="nonSchoolDates"
                (onSelect)="checkDateValidation()"
                (onInput)="checkDateValidation($event)"
                #calStartDate
              >
                <ng-template pTemplate="date" let-date>
                  <table class="hight-inherit">
                    <tr>
                      <td
                        [ngClass]="{
                          highlightDate: checkDateForExclusion(date)
                        }"
                      >
                        {{ date.day }}
                      </td>
                    </tr>
                  </table>
                </ng-template>
                <p-footer>
                  <div class="calendar-footer-details">
                    <hr class="highlightDateColorCode" />
                    <div class="margin-one-half-rem">
                      <p>Exclusion exists</p>
                    </div>
                  </div>
                </p-footer>
              </p-datepicker>
            </div>
            @if (isStartTimeVisible) {
              <div>
                <p-select
                  formControlName="startTime"
                  class="time"
                  [options]="timeList"
                  optionLabel="description"
                  optionValue="value"
                  (onChange)="populateCalculatedFields()"
                  #dropdownStartTime
                ></p-select>
              </div>
            }
            @if (
              (f.startDate.invalid && f.startDate.touched) || f.startDate.dirty
            ) {
              <div class="clear-both">
                @if (f.startDate.errors?.required) {
                  <small class="error-label"
                    >Start date is required and it should be on a school
                    day</small
                  >
                }
                @if (f.startDate.errors?.isInvalidStartDate) {
                  <small class="error-label"
                    >Start date should be on or before the end date</small
                  >
                }
                @if (f.startDate.errors?.isOverlappedWithPermExclusion) {
                  <small class="error-label"
                    >Exclusion start date cannot overlap with an existing
                    permanent exclusion</small
                  >
                }
                @if (isStartDateOverlapped) {
                  <div>
                    <small>Start date overlaps an existing exclusion</small>
                    <br />
                  </div>
                }
                @if (f.startDate.errors?.nonSchoolDateEntered) {
                  <small class="error-label"
                    >Start date should be on a school day</small
                  >
                }
                @if (f.startDate.errors?.invalidDateFormat) {
                  <small class="error-label">Invalid date format</small>
                }
                @if (f.startDate.errors?.isStartDateAfterDateOffRoll) {
                  <small class="error-label">
                    Start date should be on or before date off role
                  </small>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (isEndDateVisible) {
        <div class="col-6 padding-zero">
          <div class="col-6">
            <label for="endDate"
              >End date
              @if (isEndDateRequired) {
                <span class="error-label">*</span>
              }
            </label>
            <div>
              <p-datepicker
                class="calendar-size float-left"
                dateFormat="dd/mm/yy"
                placeholder="DD/MM/YYYY"
                inputId="endDate"
                showIcon="true"
                keepInvalid="true"
                formControlName="endDate"
                autoZIndex="true"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [minDate]="minSchoolHistoryDate"
                [maxDate]="maxSchoolHistoryDate"
                [yearRange]="yearRangeNavigator"
                [disabledDates]="nonSchoolDates"
                (onSelect)="checkDateValidation()"
                (onInput)="checkDateValidation($event)"
                #calEndDate
              >
                <ng-template pTemplate="date" let-date>
                  <table class="hight-inherit">
                    <tr>
                      <td
                        [ngClass]="{
                          highlightDate: checkDateForExclusion(date)
                        }"
                      >
                        {{ date.day }}
                      </td>
                    </tr>
                  </table> </ng-template
                ><p-footer>
                  <div class="calendar-footer-details">
                    <hr class="highlightDateColorCode" />
                    <div class="margin-one-half-rem">
                      <p>Exclusion exists</p>
                    </div>
                  </div>
                </p-footer></p-datepicker
              >
            </div>
            @if (isEndTimeVisible) {
              <div>
                <p-select
                  formControlName="endTime"
                  class="time"
                  [options]="timeList"
                  optionLabel="description"
                  optionValue="value"
                  (onChange)="populateCalculatedFields()"
                  #dropdownEndTime
                ></p-select>
              </div>
            }
            @if ((f.endDate.invalid && f.endDate.touched) || f.endDate.dirty) {
              <div class="clear-both">
                @if (f.endDate.errors?.required) {
                  <small class="error-label"
                    >End date is required and it should be on a school
                    day</small
                  >
                }
                @if (f.endDate.errors?.isInvalidEndDate) {
                  <small class="error-label"
                    >End date must be on or after the start date</small
                  >
                }
                @if (f.endDate.errors?.isOverlappedWithPermExclusion) {
                  <small class="error-label"
                    >Exclusion end date cannot overlap with an existing
                    permanent exclusion</small
                  >
                }
                @if (isEndDateOverlapped) {
                  <div>
                    <small>End date overlaps an existing exclusion</small>
                    <br />
                  </div>
                }
                @if (f.endDate.errors?.invalidDateFormat) {
                  <small class="error-label">Invalid date format</small>
                }
                @if (f.endDate.errors?.nonSchoolDateEntered) {
                  <small class="error-label"
                    >End date should be on a school day</small
                  >
                }
                @if (f.endDate.errors?.dateBeforeExclStartDate) {
                  <small class="error-label"
                    >End date should not be before exclusion start date</small
                  >
                }
              </div>
            }
          </div>
        </div>
      }
      @if (isNumberOfLunchtimesVisible) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-6">
              <label for="numberOfLunchtimes">Number of lunchtimes </label>
              <div>
                <p-inputNumber
                  formControlName="excludedLunchTimes"
                  class="form-control"
                  inputId="numberOfLunchtimes"
                ></p-inputNumber>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isExcludedDaysOffsetVisible) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-6">
              <label for="excludedDaysOffset">Offset excluded days</label>
              <div>
                <p-inputNumber
                  [showButtons]="true"
                  formControlName="excludedDaysOffset"
                  min="0"
                  max="100"
                  [step]="0.5"
                  class="form-control"
                  inputId="excludedDaysOffset"
                  (onBlur)="populateCalculatedFields()"
                  (onInput)="populateCalculatedFields()"
                  [minFractionDigits]="1"
                  [maxFractionDigits]="1"
                  #offSetExcludedDaysInput
                >
                </p-inputNumber>
              </div>
              <div>
                <div>
                  @if (f.excludedDaysOffset.errors?.isOffsetInputInvalid) {
                    <small class="error-label">
                      Offset value must be in increments of 0.5
                    </small>
                  }
                </div>
                <div>
                  @if (f.excludedDaysOffset.errors?.isInvalidOffset) {
                    <small class="error-label"
                      >Offset should not be equal or more than number of days
                      excluded</small
                    >
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isExcludedDaysDateVisible) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-6">
              <label for="excludedDaysDate"
                >Days excluded to date<span class="red">*</span></label
              >
              <div>
                <p-inputNumber
                  [min]="1"
                  [max]="100"
                  [showButtons]="true"
                  formControlName="ExcludedDaysDate"
                  class="form-control"
                  inputId="excludedDaysDate"
                ></p-inputNumber>
              </div>
            </div>
          </div>
        </div>
      }
      @if (exclusionSummaryText) {
        <div class="col-12">
          <span>{{ exclusionSummaryText }}</span>
        </div>
      }
      @if (isDateOffRollVisible) {
        <div class="col-6 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-12">
              <label for="dateOffRoll">Date off roll</label>
              <div>
                <p-datepicker
                  class="calendar-size"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  inputId="dateOffRoll"
                  keepInvalid="true"
                  [minDate]="exclusionStartDate"
                  showIcon="true"
                  [maxDate]="maxSchoolHistoryDate"
                  [disabledDates]="nonSchoolDates"
                  formControlName="dateOffRoll"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [yearRange]="yearRangeNavigator"
                  (onInput)="validManualDateEntry($event)"
                  #calDateOffRoll
                ></p-datepicker>
              </div>
              @if (
                (f.dateOffRoll.invalid && f.dateOffRoll.touched) ||
                f.dateOffRoll.dirty
              ) {
                <div>
                  @if (f.dateOffRoll.errors?.invalidDateFormat) {
                    <small class="error-label"> Invalid date format </small>
                  }
                  @if (f.dateOffRoll.errors?.isDateOffRollBeforeStartDate) {
                    <small class="error-label">
                      Date off roll should not be before exclusion start date
                    </small>
                  }
                  @if (f.dateOffRoll.errors?.nonSchoolDateEntered) {
                    <small class="error-label">
                      Date off roll should be on a school day
                    </small>
                  }
                  @if (f.dateOffRoll.errors?.dateAfterAcademicYearEndDate) {
                    <small class="error-label">
                      Date off roll should not be after academic year end date
                    </small>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isEndMonitoringDateVisible) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-6">
              <label for="endMonitorDate">End monitoring date</label>
              <div>
                <p-datepicker
                  class="calendar-size"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  inputId="endMonitorDate"
                  keepInvalid="true"
                  showIcon="true"
                  formControlName="endMonitorDate"
                  autoZIndex="true"
                  [minDate]="exclusionStartDate"
                  [maxDate]="maxEndMonitoringDate"
                  [disabledDates]="nonSchoolDates"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [yearRange]="yearRangeNavigator"
                  (onInput)="checkEndMonitoringDateValidation($event)"
                  #calEndMonitoringDate
                ></p-datepicker>
              </div>
              @if (
                (f.endMonitorDate.invalid && f.endMonitorDate.touched) ||
                f.endMonitorDate.dirty
              ) {
                <div>
                  @if (f.endMonitorDate.errors?.isInvalidMonitorDate) {
                    <small class="error-label"
                      >End monitoring date should be within the exclusion period
                      and on a school day</small
                    >
                  }
                  @if (f.endMonitorDate.errors?.invalidDateFormat) {
                    <small class="error-label">Invalid date format</small>
                  }
                  @if (f.endMonitorDate.errors?.dateBeforeExclStartDate) {
                    <small class="error-label"
                      >End monitoring date should not be before exclusion start
                      date</small
                    >
                  }
                  @if (f.endMonitorDate.errors?.dateAfterExclEndDate) {
                    <small class="error-label"
                      >End monitoring date should not be after exclusion end
                      date</small
                    >
                  }
                  @if (f.endMonitorDate.errors?.dateAfterAcademicYearEndDate) {
                    <small class="error-label"
                      >End monitoring date should not be after academic year end
                      date</small
                    >
                  }
                  @if (f.endMonitorDate.errors?.nonSchoolDateEntered) {
                    <small class="error-label"
                      >End monitoring date should be on a school day</small
                    >
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isSixthDayVisible) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-6">
              <label for="sixthDay">Sixth day</label>
              <div>
                <p-datepicker
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  inputId="sixthDay"
                  formControlName="sixthDay"
                  autoZIndex="true"
                ></p-datepicker>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isLengthToDateVisible) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-6">
              <label for="lengthToDate">Length to date</label>
              <div>
                <p-inputNumber
                  inputId="lengthToDate"
                  formControlName="lengthToDate"
                ></p-inputNumber>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isLACVisible) {
        <div class="col-12">
          <p-checkbox
            binary="true"
            formControlName="inCareWhenExcluded"
            inputId="inCareWhenExcluded"
          >
          </p-checkbox>
          <label for="inCareWhenExcluded" class="ml-2">
            LAC on exclusion start date
          </label>
        </div>
      }
      @if (isSenStatusVisible) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <div class="col-6">
              <label
                class="float-left margin-bottom-half-rem"
                for="senStageWhenExcluded"
                >SEN status on exclusion start date
              </label>
              <div>
                <p-select
                  formControlName="senStageWhenExcluded"
                  inputId="senStageWhenExcluded"
                  [options]="senStatusList"
                  optionLabel="description"
                  optionValue="description"
                  placeholder="Please select"
                  #senStatusDropdown
                ></p-select>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isPastoralVisible) {
        <div class="col-12">
          <p-checkbox
            binary="true"
            formControlName="pastoralRecd"
            inputId="pastoralRecd"
          >
          </p-checkbox>
          <label for="pastoralRecd" class="ml-2">
            A Pastoral support plan has been received</label
          >
        </div>
      }
      @if (isReinstateDateVisible) {
        <div class="col-6 padding-zero">
          <div class="col-6">
            <div>
              <label for="reInstateDate">Reinstate date </label>
              <div>
                <p-datepicker
                  class="calendar-size"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  inputId="reInstateDate"
                  keepInvalid="true"
                  showIcon="true"
                  formControlName="reinstateDate"
                  autoZIndex="true"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [yearRange]="yearRangeNavigator"
                  [minDate]="exclusionStartDate"
                  [disabledDates]="nonSchoolDates"
                  [maxDate]="maxReinstateDate"
                  (onSelect)="populateCalculatedFields()"
                  (onInput)="populateCalculatedFields($event)"
                  #calReinstateDate
                ></p-datepicker>
              </div>
              @if (
                (f.reinstateDate.invalid && f.reinstateDate.touched) ||
                f.reinstateDate.dirty
              ) {
                <div>
                  @if (f.reinstateDate.errors?.invalidDateFormat) {
                    <small class="error-label">Invalid date format</small>
                  }
                  @if (f.reinstateDate.errors?.dateBeforeExclStartDate) {
                    <small class="error-label"
                      >Reinstate date should not be before exclusion start
                      date</small
                    >
                  }
                  @if (f.reinstateDate.errors?.dateAfterExclEndDate) {
                    <small class="error-label"
                      >Reinstate date should not be after exclusion end
                      date</small
                    >
                  }
                  @if (f.reinstateDate.errors?.dateAfterAcademicYearEndDate) {
                    <small class="error-label"
                      >Reinstate date should not be after academic year end
                      date</small
                    >
                  }
                  @if (f.reinstateDate.errors?.nonSchoolDateEntered) {
                    <small class="error-label"
                      >Reinstate date should be on a school day</small
                    >
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isReinstateReasonVisible) {
        <div class="col-6 padding-zero">
          <div class="col-6">
            <div>
              <label for="reinstateReason">Reinstate reason</label>
              <div>
                <p-select
                  formControlName="reinstateReason"
                  [options]="reinstateReasonList"
                  optionLabel="description"
                  optionValue="description"
                  inputId="reinstateReason"
                  placeholder="Please select"
                  #reinstateReasonDropdown
                ></p-select>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isWithdrawnDateVisible) {
        <div class="col-6 padding-zero">
          <div class="col-6">
            <div>
              <label for="withdrawnDate"
                >Withdrawn date <span class="error-label">*</span></label
              >
              <div>
                <p-datepicker
                  class="calendar-size"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  inputId="withdrawnDate"
                  showIcon="true"
                  keepInvalid="true"
                  formControlName="withdrawnDate"
                  autoZIndex="true"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [yearRange]="yearRangeNavigator"
                  [minDate]="exclusionStartDate"
                  [disabledDates]="nonSchoolDates"
                  [maxDate]="maxReinstateDate"
                  (onInput)="checkWithdrawnDateValidation($event)"
                  #calWithdrawnDate
                ></p-datepicker>
              </div>
              @if (
                (f.withdrawnDate.invalid && f.withdrawnDate.touched) ||
                f.withdrawnDate.dirty
              ) {
                <div class="clear-both">
                  @if (f.withdrawnDate.errors?.required) {
                    <small class="error-label"
                      >Withdrawn date is required</small
                    >
                  }
                  @if (f.withdrawnDate.errors?.invalidDateFormat) {
                    <small class="error-label">Invalid date format</small>
                  }
                  @if (f.withdrawnDate.errors?.dateBeforeExclStartDate) {
                    <small class="error-label"
                      >Withdrawn date should not be before exclusion start
                      date</small
                    >
                  }
                  @if (f.withdrawnDate.errors?.dateAfterExclEndDate) {
                    <small class="error-label"
                      >Withdrawn date should not be after exclusion end
                      date</small
                    >
                  }
                  @if (f.withdrawnDate.errors?.dateAfterAcademicYearEndDate) {
                    <small class="error-label"
                      >Withdrawn date should not be after academic year end
                      date</small
                    >
                  }
                  @if (f.withdrawnDate.errors?.nonSchoolDateEntered) {
                    <small class="error-label"
                      >Withdrawn date should be on a school day</small
                    >
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isWithdrawnReasonVisible) {
        <div class="col-6 padding-zero">
          <div class="col-6">
            <div>
              <label for="withdrawnReason"
                >Withdrawn reason <span class="error-label">*</span></label
              >
              <div>
                <p-select
                  formControlName="withdrawnReason"
                  [options]="withdrawnReasonList"
                  optionLabel="description"
                  optionValue="description"
                  inputId="withdrawnReason"
                  placeholder="Please select"
                  #withdrawnReasonDropdown
                ></p-select>
              </div>
              @if (
                (f.withdrawnReason.invalid && f.withdrawnReason.touched) ||
                f.withdrawnReason.dirty
              ) {
                <div class="clear-both">
                  @if (f.withdrawnReason.errors?.required) {
                    <small class="error-label"
                      >Withdrawn reason is required</small
                    >
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (isEditable) {
      <div class="grid align-right">
        <div class="col">
          <button
            type="button"
            title="cancel"
            label="Cancel"
            (click)="toggleEditing()"
            pButton
            class="button-custom margin-right"
          ></button>
          <button
            type="button"
            title="save"
            label="Save"
            pButton
            class="button-custom margin-right"
            (click)="saveExclusion()"
            [disabled]="isSaveClicked"
          ></button>
        </div>
      </div>
    }
  </form>
}
@if (isLoading) {
  <core-spin-loader></core-spin-loader>
}
